import { useState, useEffect, useCallback } from 'react';

/**
 * Hook to be subscribed to changes on window size. Ready to
 * be user on code that uses SSR. Based on:
 * https://usehooks.com/useWindowSize/
 */

const useWindowSize = () => {
	const isClient = typeof window === 'object';

	const getSize = useCallback(() => {
		return {
			width: isClient ? window.innerWidth : undefined,
			height: isClient ? window.innerHeight : undefined,
		};
	}, [isClient]);

	const [windowSize, setWindowSize] = useState(getSize);

	useEffect(() => {
		if (!isClient) {
			return false;
		}

		const handleResize = () => {
			setWindowSize(getSize());
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [isClient, getSize]);

	return windowSize;
};

export default useWindowSize;
